<div class="top-shift">
    <br />
    <img alt="emit" class="system-logo" src="assets/images/logos/logo.png" />
    <br />
    <div class="login-container clearfix divider-content">
        @if (isError) {
            <div class="text-danger text-center">{{ errorString }}</div>
        }
        @if (!isUsingSsoLogin) {
            <form #myForm (submit)="onSubmit()" [formGroup]="loginForm">
                <div class="row">
                    <pcg-control-group class="col-sm-12" label="Username">
                        <input
                            pcgControlRef
                            formControlName="userName"
                            type="text"
                            maxlength="51"
                            class="form-control"
                        />
                    </pcg-control-group>
                </div>

                <div class="row">
                    <pcg-show-hide-password
                        class="col-sm-12"
                        [controlName]="'password'"
                        [parentForm]="loginForm"
                        label="Password"
                        inputCssClass="form-control"
                    ></pcg-show-hide-password>
                </div>

                <button type="submit" class="btn btn-default btn-lg">Login</button>
                <a class="float-right" routerLink="/forgot-password">Forgot your password?</a>
                <a class="anchor" (click)="switchSso()">{{ isUsingSsoLogin ? 'Regular Login' : 'Login With SSO' }}</a>
            </form>
        } @else {
            <form (ngSubmit)="ssoLogin()">
                <div class="row">
                    <pcg-control-group class="col-sm-12" label="Email">
                        <input
                            type="text"
                            maxlength="51"
                            pcgControlRef
                            [(ngModel)]="ssoEmail"
                            class="form-control"
                            id="ssoEmail"
                            name="ssoEmail"
                            autocomplete="on"
                        />
                    </pcg-control-group>
                </div>

                <button type="submit" class="btn btn-secondary btn-lg" (click)="ssoLogin()">Login</button>
                <a class="anchor" (click)="switchSso()">{{ isUsingSsoLogin ? 'Regular Login' : 'Login With SSO' }}</a>
            </form>
        }
    </div>
</div>
